import { Users } from 'lucide-react';
import { hrmsGet } from '../../api/api';
import LiveDashboardPage from './LiveDashboardPage';

export default function HRDashboardPage() {
  return <LiveDashboardPage title="HR" description="Human Resources" icon={Users} getData={hrmsGet} />;
}